import { render, staticRenderFns } from "./InputPreview.vue?vue&type=template&id=bbf4ac90&"
import script from "./InputPreview.vue?vue&type=script&lang=js&"
export * from "./InputPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports